import { Typography, Box, Container, Button, Paper, Chip } from '@mui/material';
import { ShoppingCart } from '@mui/icons-material';
import React from 'react';

type Props = {};

const RonPageLayout = (props: Props) => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        gap: 4,
        mb: 4
      }}>
        {/* Book Image Section */}
        <Box sx={{ 
          flex: { xs: '1', md: '0 0 40%' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <Paper
            elevation={4}
            sx={{
              overflow: 'hidden',
              borderRadius: 2,
              maxWidth: '400px',
              width: '100%'
            }}
          >
            <img 
              src='/phil-holding-ron.jpeg' 
              alt='Phil in a red shirt holding his book, Ron'
              style={{
                width: '100%',
                height: 'auto',
                display: 'block'
              }}
            />
          </Paper>
        </Box>

        {/* Book Details Section */}
        <Box sx={{ flex: 1 }}>
          <Typography 
            variant="h1" 
            sx={{ 
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              fontWeight: 700,
              color: '#2c3e50',
              mb: 1,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}
          >
            RON
          </Typography>
          
          <Box sx={{ mb: 3 }}>
            <Chip 
              label="ISBN: 979-8455389184" 
              sx={{ 
                backgroundColor: '#ecf0f1',
                color: '#2c3e50',
                fontFamily: 'monospace',
                fontSize: '0.9rem'
              }} 
            />
          </Box>

          <Button
            variant="contained"
            startIcon={<ShoppingCart />}
            href="https://www.amazon.co.uk/RON-Philip-Payne/dp/B09CKL2TC3"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: '#e74c3c',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              mb: 4,
              '&:hover': {
                backgroundColor: '#c0392b'
              },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Purchase on Amazon
          </Button>

          <Paper
            elevation={0}
            sx={{
              p: 3,
              backgroundColor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: '1.5rem', md: '1.75rem' },
                fontWeight: 600,
                color: '#2c3e50',
                mb: 2,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
              }}
            >
              About the Book
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                '& + &': {
                  marginTop: 2
                }
              }}
            >
              The first book published by Phil follows the story of the titular character.
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                mt: 2
              }}
            >
              After trying to break up a bar fight, Ron finds himself wrongly accused of assaulting a couple of police officers. He serves his time and all he wants now is to settle down into a simple life and be left alone. The only trouble is, he has a habit of being in the wrong place at the wrong time.
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                mt: 2
              }}
            >
              With his heart in the right place, he is never one to shy away from offering help to any who need it, even though he knows the good deed will mostly backfire.
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                mt: 2
              }}
            >
              Shortly after being released from prison Ron finds himself at rock bottom. Surely his luck can only take him in one direction from now. How wrong he is.
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                lineHeight: 1.9,
                color: '#444',
                fontFamily: 'Georgia, serif',
                mt: 2
              }}
            >
              Recruited to carry out questionable deeds by a questionable government department, Ron finds himself walking a thin line between right and wrong. That very line becomes smudged when he meets a woman standing on the other side who makes him question his actions.
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Container>
  );
};

export default RonPageLayout;
